/**
 * @generated SignedSource<<327a1e7b651106e7c6285248802ea97d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type DeletionReason = "AUTO" | "MANUAL";
export type NoteStreamType = "goalset" | "meeting" | "oneonone" | "personal";
export type RecordingMediaType = "AUDIO" | "VIDEO";
import { FragmentRefs } from "relay-runtime";
export type Notes_note$data = {
  readonly id: string;
  readonly meetingRecordings: ReadonlyArray<{
    readonly activeSummary: {
      readonly id: string;
    } | null;
    readonly clips: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ClipsPanel_ClipSummary_clip">;
    }> | null;
    readonly hasExternalAttendees: boolean;
    readonly id: string;
    readonly isCurrentlyRecording: boolean | null;
    readonly isFavourite: boolean;
    readonly mediaType: RecordingMediaType;
    readonly meetingCallEnd: string | null;
    readonly meetingCallStart: string;
    readonly meetingRecordedVideoUrl: string | null;
    readonly meetingVideoAndTranscriptionDownloadUrl: string | null;
    readonly ownerAccount: {
      readonly id: string;
    };
    readonly subtitlesVttUrl: string;
    readonly thumbnailVttUrl: string | null;
    readonly title: string;
    readonly transcript: any | null;
    readonly transcriptDeletionReason: DeletionReason | null;
    readonly viewerCanDelete: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"ChaptersPanel_meetingRecording" | "ClipCutModal_meetingRecording" | "ClipsPanel_meetingRecording" | "HighlightsPanel_meetingRecording" | "MeetingHeader_meetingRecording" | "MeetingRecap_meetingRecording" | "RecapHistory_meetingRecording" | "Timeline_meetingKeyEvents" | "TranscriptPanel_Transcript_meetingRecording" | "TranscriptVideo_meetingRecording" | "useMeetingRecordingWebsocket_meetingRecording" | "utils_AddedOrAvailableUntil_meetingRecording" | "utils_useGetURL_recording" | "utils_useLongestMeetingRecording_meetingRecordings">;
  }> | null;
  readonly stream: {
    readonly id: string;
    readonly type: NoteStreamType;
  };
  readonly " $fragmentSpreads": FragmentRefs<"MeetingContent_note" | "MeetingPhaseContext_note">;
  readonly " $fragmentType": "Notes_note";
};
export type Notes_note$key = {
  readonly " $data"?: Notes_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"Notes_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = [
  {
    "kind": "Literal",
    "name": "public",
    "value": false
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Notes_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecording",
      "kind": "LinkedField",
      "name": "meetingRecordings",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "meetingCallStart",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "meetingCallEnd",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "meetingVideoAndTranscriptionDownloadUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "meetingRecordedVideoUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subtitlesVttUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "thumbnailVttUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isFavourite",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanDelete",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasExternalAttendees",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "transcript",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "transcriptDeletionReason",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCurrentlyRecording",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MeetingRecordingSummary",
          "kind": "LinkedField",
          "name": "activeSummary",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MeetingRecordingClip",
          "kind": "LinkedField",
          "name": "clips",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ClipsPanel_ClipSummary_clip"
            }
          ],
          "storageKey": null
        },
        {
          "args": (v2/*: any*/),
          "kind": "FragmentSpread",
          "name": "TranscriptPanel_Transcript_meetingRecording"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MeetingRecap_meetingRecording"
        },
        {
          "args": (v2/*: any*/),
          "kind": "FragmentSpread",
          "name": "TranscriptVideo_meetingRecording"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ClipCutModal_meetingRecording"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "utils_useLongestMeetingRecording_meetingRecordings"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "utils_AddedOrAvailableUntil_meetingRecording"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "utils_useGetURL_recording"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RecapHistory_meetingRecording"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Timeline_meetingKeyEvents"
        },
        {
          "args": (v2/*: any*/),
          "kind": "FragmentSpread",
          "name": "HighlightsPanel_meetingRecording"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ChaptersPanel_meetingRecording"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ClipsPanel_meetingRecording"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useMeetingRecordingWebsocket_meetingRecording"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MeetingHeader_meetingRecording"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "ownerAccount",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mediaType",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingPhaseContext_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingContent_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "679e7e04b2630fd7233afa1f4721aeef";

export default node;
